import { getWindow } from '../window/Window';
import {
  getLiveChatAccountId,
  getLiveChatInvitationId,
  getLiveChatWebsiteId,
  getLiveChatChatId,
  isLiveChatEnabled,
} from '../config/ConfigService';

/*
This function is a copy pasta of the code generated by live chat. It is the same code we use in TAL.
As such, it is not tested here.

DO NOT CHANGE unless you are willing to fully test and understand what this initialise function
is doing.
*/

export const initialiseLiveChat = /* istanbul ignore next */ (): void => {
  if (!isLiveChatEnabled()) {
    return;
  }
  const global = getWindow() as any;
  global._bcvma = global._bcvma || [];

  const accountId = getLiveChatAccountId();
  const invitationId = getLiveChatInvitationId();
  const websiteId = getLiveChatWebsiteId();
  const chatId = getLiveChatChatId();
  const authenticated = false;

  global._bcvma.push(['setAccountID', accountId]);
  global._bcvma.push(['setParameter', 'WebsiteID', websiteId]);
  global._bcvma.push(['setParameter', 'InvitationID', invitationId]);
  global._bcvma.push(['setParameter', 'VisitName', '']);
  global._bcvma.push(['setParameter', 'VisitPhone', '']);
  global._bcvma.push(['setParameter', 'VisitEmail', '']);
  global._bcvma.push(['setParameter', 'VisitRef', '']);
  global._bcvma.push(['setParameter', 'VisitInfo', '']);
  global._bcvma.push(['setParameter', 'CustomUrl', '']);
  global._bcvma.push(['setParameter', 'globalParameters', '']);
  global._bcvma.push(['pageViewed']);

  global._bcvma.push(['addFloat', { type: 'chat', id: chatId }]);

  global._bcLoad = () => {
    if (global._bcLoaded) {
      return;
    }
    global._bcLoaded = true;
    const vms = document.createElement('script');
    vms.type = 'text/javascript';
    vms.async = true;
    vms.src =
      ('https:' === document.location.protocol ? 'https://' : 'http://') +
      'vmss.boldchat.com/aid/' +
      accountId +
      '/bc.vms4/vms.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(vms, s);
  };

  if (global.pageViewer && global.pageViewer.load) {
    global.pageViewer.load();
  } else if (!authenticated) {
    if (document.readyState === 'complete') {
      global._bcLoad();
    } else if (global.addEventListener) {
      global.addEventListener('load', global._bcLoad, false);
    } else {
      global.attachEvent('onload', global._bcLoad);
    }
  }
};

export const destroyLiveChat = () => {
  removeHiddenForm();
  removeChatbar();
  removeSidebar();
};

const removeHiddenForm = () => {
  const liveChatHiddenForm = getWindow().document.querySelector('form[target=bc-window]');
  if (liveChatHiddenForm) {
    liveChatHiddenForm.parentNode.removeChild(liveChatHiddenForm);
  }
};

const removeChatbar = () => {
  const liveChatChatbar = getWindow().document.getElementById('bc-chat-container');
  if (liveChatChatbar) {
    liveChatChatbar.parentNode.removeChild(liveChatChatbar);
  }
};

const removeSidebar = () => {
  const liveChatSidebarElements = getWindow().document.getElementsByClassName('bcFloat');
  if (liveChatSidebarElements) {
    Array.from(liveChatSidebarElements).forEach((element) =>
      element.parentNode.removeChild(element),
    );
  }
};
